import Link from 'next/link';
import { useRouter } from 'next/router';
import { ComponentProps } from 'react';

import useLinkProps from '../../../../hooks/use-link-props';

type useModelVersionLinkProps = {
  isPicker?: boolean;
  have_versions: boolean;
  slug: string;
};

const useModelVersionLink = ({
  isPicker = false,
  have_versions,
  slug,
}: useModelVersionLinkProps): ComponentProps<typeof Link> => {
  const { locale = 'en', query, route, asPath } = useRouter();
  const getLinkProps = useLinkProps();

  const hasPart = query.category && query.subCategory;

  if (isPicker) {
    if (have_versions) {
      // x host and domain (not important for the purpose)
      const newAsPath = new URL(`x:${asPath}`);
      newAsPath.searchParams.set('picker', 'version');
      return {
        href: {
          href: route,
          query: {
            ...query,
            picker: 'version',
          },
        },
        as: `${newAsPath.pathname}${newAsPath.search}`,
      };
    } else {
      //remove picker from query
      const { picker, ...queryToKeep } = query;

      // x host and domain (not important for the purpose)
      const newAsPath = new URL(`x:${asPath}`);
      newAsPath.searchParams.delete('picker');

      return {
        href: {
          href: route,
          query: queryToKeep,
        },
        as: `${newAsPath.pathname}${newAsPath.search}`,
      };
    }
  } else if (have_versions) {
    if (hasPart) {
      return getLinkProps('versions-with-part', {
        model: slug,
        category: query.category as string,
        subCategory: query.subCategory as string,
      });
    } else {
      return getLinkProps('versions', { model: slug });
    }
  } else if (hasPart) {
    return getLinkProps('search', {
      category: query.category as string,
      subCategory: query.subCategory as string,
      vehicle: slug,
    });
  } else {
    // we are using category slug instead of vehicle because of next file system logic
    return getLinkProps('categories-with-vehicle', {
      category: slug,
    });
  }
};

export default useModelVersionLink;
